import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'
import { castingStoreAvailableCustomerPlanSubscriptions, StoreProps } from '../../../../services/stores/casting.store'
import { PrimaryButton } from '../casting-styled.component'
import CustomerPlanDescriptionComponent from './customer-plan-description.component'

const i18nScoped = new I18nService(require('./casting-pending-customer-plan-subscription.component.yml'))

export default function CastingPendingCustomerPlanSubscriptionComponent ({ store, data: { customer, offeredService } }: StoreProps) {
  const pendingSubscription = React.useMemo(
    () => castingStoreAvailableCustomerPlanSubscriptions({ customer, offeredService }).find(_ => !_.validated_at),
    [customer, offeredService]
  )

  const handleContinue = React.useCallback(() => store.nextFocus({ closeOnMobile: true }), [store])
  const handleCancel = React.useCallback(() => store.set({ customerPlanSubscriptionRemovePendingId: pendingSubscription?.id ?? null }), [store, pendingSubscription])

  return <>
    <p style={{ textAlign: 'justify' }}>{ i18nScoped.tFragment('you_have_pending_subscription', { name: <b>{ pendingSubscription.customer_plan.name }</b> }) }</p>

    <CustomerPlanDescriptionComponent
      customerPlan={{ ...pendingSubscription.customer_plan, offered_service_ids: pendingSubscription.offered_services.map(_ => _.id) }}
      offeredServices={ pendingSubscription.offered_services } />

    <PrimaryButton
      style={{ display: 'block', marginTop: '1em' }}
      id="js-test-tooltip-next"
      onClick={ handleContinue }
      children={ i18nScoped.t('continue_with_subscription') } />

    <PrimaryButton
      style={{ display: 'block', marginTop: '0.5em' }}
      onClick={ handleCancel }
      children={ i18nScoped.t('cancel_subscription') } />
  </>
}
